import { render, staticRenderFns } from "./Faa.vue?vue&type=template&id=6d56d044&"
import script from "./Faa.vue?vue&type=script&lang=js&"
export * from "./Faa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports